import { render, staticRenderFns } from "./cmplistarpedidosifood.vue?vue&type=template&id=28a21a30&"
import script from "./cmplistarpedidosifood.vue?vue&type=script&lang=js&"
export * from "./cmplistarpedidosifood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports